import { render, staticRenderFns } from "./vVideo.vue?vue&type=template&id=0cef45f9&scoped=true"
import script from "./vVideo.vue?vue&type=script&lang=js"
export * from "./vVideo.vue?vue&type=script&lang=js"
import style0 from "./vVideo.vue?vue&type=style&index=0&id=0cef45f9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cef45f9",
  null
  
)

export default component.exports